export default __webpack_public_path__ + "static/media/notFoundBg.0107039a.svg";